import './Pult.css'
import { ReactComponent as Arrow } from './arrow.svg'

const Pult = ({ goBack, goNext }) => {
  return (
    <div className='pult'>
      <div onClick={goBack} className='btn'>
        <Arrow className='arrow' />
      </div>
      <div onClick={goNext} className='btn active'>
        <Arrow className='arrow' />
      </div>
    </div>
  )
}

export default Pult
